import React from 'react';

export interface CloseIconProps {
  width?: string;
  height?: string;
}

const CloseIcon: React.FC<CloseIconProps> = (props): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <path
        d="M304.628-254.343a9.015,9.015,0,0,1,12.734,0,9.015,9.015,0,0,1,0,12.734,9.015,9.015,0,0,1-12.734,0A9.015,9.015,0,0,1,304.628-254.343Zm1.181,1.181a7.342,7.342,0,0,0,0,10.372,7.341,7.341,0,0,0,10.371,0,7.342,7.342,0,0,0,0-10.371A7.342,7.342,0,0,0,305.81-253.161Zm1.722,1.722a.765.765,0,0,1,1.082,0h0L311-249.057l2.381-2.381a.765.765,0,0,1,1.082,0,.765.765,0,0,1,0,1.082h0l-2.381,2.381,2.381,2.382a.765.765,0,0,1,0,1.082.765.765,0,0,1-1.082,0h0L311-246.893l-2.381,2.381a.765.765,0,0,1-1.082,0,.765.765,0,0,1,0-1.082h0l2.381-2.381-2.381-2.381A.765.765,0,0,1,307.532-251.439Z"
        transform="translate(-301.996 256.975)"
      />
    </svg>
  );
};
export default CloseIcon;
